import React, { useRef } from 'react';
import './UploadIconBox.css';

const IconUploadButton = ({ icon, onIconChange, readOnly = false }) => {
    const fileInputRef = useRef(null);

    // ── Derive display src: File → object URL, string → use as-is, null → nothing
    const previewSrc = icon instanceof File
        ? URL.createObjectURL(icon)
        : (typeof icon === 'string' && icon.length > 0 ? icon : null);

    const handleClick = () => {
        if (readOnly) return;
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        onIconChange(file); // raw File — let the parent manage it
        e.target.value = '';
    };

    const handleRemove = (e) => {
        e.stopPropagation();
        onIconChange(null);
    };

    return (
        <>
            {!readOnly && (
                <input
                    type="file"
                    accept="image/*"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                />
            )}
            <div
                className='release-feature-content-empty icon-upload-wrapper'
                onClick={handleClick}
                style={{
                    cursor: readOnly ? 'default' : 'pointer',
                    position: 'relative',
                    display: 'inline-flex'
                }}
                title={readOnly ? '' : 'Click to upload icon'}
            >
                {previewSrc ? (
                    <>
                        <img
                            src={previewSrc}
                            alt="feature icon"
                            style={{ width: '20px', height: '20px', objectFit: 'contain' }}
                        />
                        {!readOnly && (
                            <span className='icon-remove-btn' onClick={handleRemove}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                    <rect width="15" height="15" rx="7.5" fill="#FF0000"/>
                                    <path d="M11.0625 3.75L3.75 11.0625" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M3.75 3.75L11.0625 11.0625" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </span>
                        )}
                    </>
                ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className='release-feature-empty-icon'>
                        <path d="M10 2.5H4.16667C3.72464 2.5 3.30072 2.67559 2.98816 2.98816C2.67559 3.30072 2.5 3.72464 2.5 4.16667V15.8333C2.5 16.2754 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H15.8333C16.2754 17.5 16.6993 17.3244 17.0118 17.0118C17.3244 16.6993 17.5 16.2754 17.5 15.8333V10" stroke="#535353" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M15.3125 2.18769C15.644 1.85617 16.0937 1.66992 16.5625 1.66992C17.0313 1.66992 17.481 1.85617 17.8125 2.18769C18.144 2.51921 18.3303 2.96885 18.3303 3.43769C18.3303 3.90653 18.144 4.35617 17.8125 4.68769L10.3017 12.1994C10.1038 12.3971 9.85933 12.5418 9.59083 12.6202L7.19666 13.3202C7.12496 13.3411 7.04895 13.3424 6.97659 13.3238C6.90423 13.3053 6.83819 13.2676 6.78537 13.2148C6.73255 13.162 6.6949 13.096 6.67637 13.0236C6.65783 12.9512 6.65908 12.8752 6.68 12.8035L7.38 10.4094C7.45877 10.1411 7.60378 9.8969 7.80166 9.69936L15.3125 2.18769Z" stroke="#535353" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                )}
            </div>
        </>
    );
};

export default IconUploadButton;